export default "__VITE_ASSET__8ba2c15a__"